import { atom } from 'jotai';

export const piiModalOpenAtom = atom<boolean>(false);
